import { render, staticRenderFns } from "./EditEventDescription.vue?vue&type=template&id=185dd3f2&"
import script from "./EditEventDescription.vue?vue&type=script&lang=js&"
export * from "./EditEventDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports